// Editorial background article for the "州选解码" modal, keyed by state slug.
// Stored here (not in public/config.js) so it is not overwritten by the
// dashboard cache pipeline. Blocks are separated by blank lines; a line wrapped
// in <heading>…</heading> is a section title, a bare image URL becomes an inline
// figure, everything else is a paragraph. See BackgroundStories.jsx for parsing.

const johor_zh_CN = `
柔佛是马来半岛最早举行州级选举的州属之一。1954年，在英殖民政府推动地方自治的背景下，柔佛于同年10月10日迎来历史上首次州议会选举，时间甚至早于1955年的马来亚首次全国大选。

回顾历史，1895年4月14日颁布的《1895年柔佛宪法》，这是马来亚首部成文宪法，开启君主立宪制的现代化治理，奠定柔佛现代统治与行政体制的基石，更是延续柔佛州自1895年以来，历经一个多世纪所建立的现代化行政与多元民主遗产。

柔佛在马来西亚建国史创下多项第一，不仅是第一个建立内阁部长理事会的州属，早在1883年就设立“州务大臣”职位，并于1873年引入“宗教司”体制，以巩固州政府的行政体系。马来亚于1957年独立后，柔佛州在1959年8月20日召开首届正式州立法议会。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.38.47_PM.jpeg

<heading>占据大马政坛举足轻重的地位</heading>
作为全国第二大人口州属，也是巫统的发源地，柔佛州在马来西亚政坛向来占据举足轻重的地位。由于拥有高度多元的族群选民结构，柔佛长期被视为最接近全国人口组成的缩影，其选举结果往往被视为全国政治风向的重要指标。

在1959年至1986年的多届选举中，国阵在柔佛维持压倒性优势，平均胜选率高达97%；1995年及1999年更曾横扫全部州议席，使柔佛长期被视为国阵定存州。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.35.33_PM.jpeg

2004年州选选区重划至56席，国阵因新加兰州议席提名失误失去竞选资格，让伊党不战而胜，成为柔佛政治松动的早期信号。

2008年大选后，国阵优势逐步被侵蚀；2013年民联攻下18席，进一步缩小差距。

2018年政治海啸中，希盟夺下柔佛政权，终结国阵长期执政。2020年土团党退出希盟，并与国阵及伊斯兰党组成新联盟，引发喜来登政变，柔佛州议会出现28对28悬峙，最终政权易手，成为首个受该政治变动影响而变天的州属。

柔州议会在2022年1月提前解散，柔佛成为继沙巴、马六甲及砂拉越之后，第四个因政治重组影响而提前举行州选的州属；在同年州选中，国阵以40席大胜重返执政，重新巩固在柔佛的优势地位。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/f14770754ce0c7f89bf9ed2165d28585.jpg

<heading>全国大选前哨战</heading>
根据大马选委会早宣布，第16届柔佛州选将于6月27日提名，7月11日投票。这也是柔佛在8年内迎来第三次州选，频密选举打破过往相对稳定的政治节奏，也凸显其在全国政治布局中的关键角色，被外界视为全国大选的前哨战。

柔佛州政治版图在过去10多年历经剧烈变化，自2013年起，国阵在柔州开始流失部分选区，当年仅赢得56席中的38席；2018年全国大选更在政治海啸冲击下骤减至19席。惟在2022年柔佛州选中出现逆转，国阵成功重夺40个州议席，重新稳住执政地位。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.37.57_PM.jpeg

2020年因“喜来登政变”引发国内政治危机，柔佛州成为继沙巴、马六甲及砂拉越之后，第4个解散州议会并举行州选的州属。2022年3月12日举行的第15届柔佛州选，亦是全国首个落实18岁至20岁自动首投族制度的州选。

目前，由国阵主导的柔佛州政府任期原定至2027年4月届满，惟基于多项考量，包括为让路民主程序及确保州政权稳定。普遍认为，若国阵再次以简单多数掌握柔州政权，将有更大空间在团结政府内进行政治谈判。

<heading>合格选民272万7296人</heading>
根据选委会早前公布的数据，柔佛州共有272万7296名合格选民，其中首投族约12万5762人；族群结构方面，巫裔选民占56.69%、华裔占35.28%、印裔占6.55%。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.36.43_PM.jpeg

由于柔佛选民结构最接近全国人口分布，本届州选被认为胜负关键，仍取决于游子选票与首投族动向。因此，2026年柔佛州选不仅是国阵巩固执政版图的防卫战，更是一场检验民意走向、牵动全国政治风向的前哨战，各政党在此形成的论述与策略，往往更容易被复制至全国大选。
`;

const johor_zh_TW = `
柔佛是馬來半島最早舉行州級選舉的州屬之一。1954年，在英殖民政府推動地方自治的背景下，柔佛於同年10月10日迎來歷史上首次州議會選舉，時間甚至早於1955年的馬來亞首次全國大選。

回顧歷史，1895年4月14日頒布的《1895年柔佛憲法》，這是馬來亞首部成文憲法，開啟君主立憲制的現代化治理，奠定柔佛現代統治與行政體制的基石，更是延續柔佛州自1895年以來，歷經一個多世紀所建立的現代化行政與多元民主遺產。

柔佛在馬來西亞建國史創下多項第一，不僅是第一個建立內閣部長理事會的州屬，早在1883年就設立「州務大臣」職位，並於1873年引入「宗教司」體制，以鞏固州政府的行政體系。馬來亞於1957年獨立後，柔佛州在1959年8月20日召開首屆正式州立法議會。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.38.47_PM.jpeg

<heading>佔據大馬政壇舉足輕重的地位</heading>
作為全國第二大人口州屬，也是巫統的發源地，柔佛州在馬來西亞政壇向來佔據舉足輕重的地位。由於擁有高度多元的族群選民結構，柔佛長期被視為最接近全國人口組成的縮影，其選舉結果往往被視為全國政治風向的重要指標。

在1959年至1986年的多屆選舉中，國陣在柔佛維持壓倒性優勢，平均勝選率高達97%；1995年及1999年更曾橫掃全部州議席，使柔佛長期被視為國陣定存州。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.35.33_PM.jpeg

2004年州選選區重劃至56席，國陣因新加蘭州議席提名失誤失去競選資格，讓伊黨不戰而勝，成為柔佛政治鬆動的早期信號。

2008年大選後，國陣優勢逐步被侵蝕；2013年民聯攻下18席，進一步縮小差距。

2018年政治海嘯中，希盟奪下柔佛政權，終結國陣長期執政。2020年土團黨退出希盟，並與國陣及伊斯蘭黨組成新聯盟，引發喜來登政變，柔佛州議會出現28對28懸峙，最終政權易手，成為首個受該政治變動影響而變天的州屬。

柔州議會在2022年1月提前解散，柔佛成為繼沙巴、馬六甲及砂拉越之後，第四個因政治重組影響而提前舉行州選的州屬；在同年州選中，國陣以40席大勝重返執政，重新鞏固在柔佛的優勢地位。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/f14770754ce0c7f89bf9ed2165d28585.jpg

<heading>全國大選前哨戰</heading>
根據大馬選委會早宣布，第16屆柔佛州選將於6月27日提名，7月11日投票。這也是柔佛在8年內迎來第三次州選，頻密選舉打破過往相對穩定的政治節奏，也凸顯其在全國政治佈局中的關鍵角色，被外界視為全國大選的前哨戰。

柔佛州政治版圖在過去10多年歷經劇烈變化，自2013年起，國陣在柔州開始流失部分選區，當年僅贏得56席中的38席；2018年全國大選更在政治海嘯衝擊下驟減至19席。惟在2022年柔佛州選中出現逆轉，國陣成功重奪40個州議席，重新穩住執政地位。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.37.57_PM.jpeg

2020年因「喜來登政變」引發國內政治危機，柔佛州成為繼沙巴、馬六甲及砂拉越之後，第4個解散州議會並舉行州選的州屬。2022年3月12日舉行的第15屆柔佛州選，亦是全國首個落實18歲至20歲自動首投族制度的州選。

目前，由國陣主導的柔佛州政府任期原定至2027年4月屆滿，惟基於多項考量，包括為讓路民主程序及確保州政權穩定。普遍認為，若國陣再次以簡單多數掌握柔州政權，將有更大空間在團結政府內進行政治談判。

<heading>合格選民272萬7296人</heading>
根據選委會早前公布的數據，柔佛州共有272萬7296名合格選民，其中首投族約12萬5762人；族群結構方面，巫裔選民佔56.69%、華裔佔35.28%、印裔佔6.55%。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.36.43_PM.jpeg

由於柔佛選民結構最接近全國人口分布，本屆州選被認為勝負關鍵，仍取決於遊子選票與首投族動向。因此，2026年柔佛州選不僅是國陣鞏固執政版圖的防衛戰，更是一場檢驗民意走向、牽動全國政治風向的前哨戰，各政黨在此形成的論述與策略，往往更容易被複製至全國大選。
`;

const negerisembilan_zh_CN = `
森美兰政治发展史可分为传统与现代两个阶段。传统上，森州源自印尼苏门答腊的米南加保传统宗族与母系习俗（Adat perpatih），实行全马独有的“四大酋长”推选最高统治者（严端，Yamtuan）的制度。

<heading>米南加保母系习俗</heading>
米南加保人来到马来半岛后，他们所组成的部落原本受到马六甲苏丹国及后来的柔佛苏丹国的保护。但在18世纪，柔佛势力衰弱后，部落领袖为了团结抵御外部，尤其是武吉斯人的威胁，决定从米南加保故乡的Pagaruyung王国，请求派遣王族成员成为他们的统治者。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.12.51_PM.jpeg

1773年，来自Pagaruyung的Raja Melewar（又称Raja Mahmud Sultan Abdul Jalil）在森美兰，击败当时已自立为统治者的Raja Khatib，柔佛苏丹因此册封Raja Melewar为第一任严端，并成为森美兰王室的开创者。

至于四大酋长，是森美兰州内地位最高的传统领袖。他们是在州属王室体制中扮演关键决策角色的传统领袖，但本身并不是君主。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.14.23_PM.jpeg

与世袭制君主不同，酋长并非采取“父传子”的直接继承方式。相反地，他们的任命遵循一套层层递进的习俗等级制度，从部族成员（Anak buah）中，选出中级首领（Buapak）、再选出高级首领（Lembaga）、最后选出酋长（Undang）。

选拔过程同样遵循米南加保母系制度，意即血统追溯自母系，尽管领导职位是由各领地合格贵族家庭中的男性出任。

森美兰四大酋长分别掌管双溪乌绒、林茂、日叻务及柔河。他们是州内传统最高领袖，在州统治体系中扮演关键角色。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.14.51_PM.jpeg

19世纪末，森美兰因为锡矿利益引发内战，英国势力趁机介入。1887年，英国与各部落酋长签署条约，正式成立森美兰联邦。

1898年，神安池的严端与四大酋长达成协议，确立了“森美兰最高统治者”的领导地位。随后，森美兰与其他三个州属（霹雳、雪兰莪及彭亨）合并为“马来联邦”后，1909年组成“联邦理事会”（Federal Council），这是马来联邦下的立法机构。

<heading>巫统长期执政</heading>
1957年马来亚独立，森美兰也在1959年举行的第1届全国大选。从1959年到2023年，森美兰总共举行过15场州选，其中前14场州选都是与全国大选同步进行。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.23.27_PM.jpeg

巫统通过联盟/国阵赢得前13场选举并长期执政，直到2018的第14届全国大选，希盟首次打破国阵的垄断，并推出公正党的拿督斯里阿敏努丁成为第11任州务大臣。

上一届（2023年）州选，森美兰与另外5州举行“六州选举”。由于这时希盟及国阵已在联邦组成昌明政府，森州希盟及国阵首次联手，结果掌握超过大部分议席，成功保住森州政权。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.18.03_PM.jpeg

<heading>宫廷大臣双重危机</heading>
2026年4月，森州爆发罕见的王室传统与宪政纠纷，最终迫使州务大臣阿敏努丁不得不提前解散州议会。

森州宫廷与酋长的分裂，起源于双溪乌绒家族议会议长（Telaga Undang）提出罢免其酋长慕巴拉克，并获得由严端为主席的司法与酋长理事会（DKU）的认可。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.18.25_PM.jpeg

在2026年4月17日的DKU会议上，严端主持会议，强行通过了终止慕巴拉克的职务，引起四大酋长强烈不满，在4月19日宣布罢黜森州最高统治者，并拥立第10任严端东姑查化之子纳扎鲁丁（Tunku Nadzaruddin Tuanku Jaafar），出任森州新任最高统治者。

阿敏努丁当晚却宣布，罢黜严端的决定无效，并认定DKU会议已是最终的决定。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.20.51_PM.jpeg

阿敏努丁的声明又激起四大酋长的不满。次日（4月20日），森州四大酋长发表联合声明，谴责州务大臣插手州统治者事务，应当被撤换。

4月23日，森美兰州议会开幕礼，四大酋长与淡边东姑勿刹，一反传统，集体缺席开幕仪式。开幕仪式一结束，森州议长马上宣布，展延州议会，复会日期另行通知。

<heading>巫统撤回支持</heading>
4月27日，巫统森州主席贾拉鲁丁在无预警下突然宣布，14名国阵巫统州议员决定撤回对森州大臣的支持。同一天，国盟的5名州议员宣布，愿意与巫统组成新政府。

根据形势，在森州议会中，希盟共有17席、国阵14席、国盟5席。若国阵加国盟，刚好可以过半。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.21.39_PM.jpeg

不过，阿敏努丁随后召开记者会指出，自己已获森州最高统治者端姑慕里兹的御准，继续出任森州大臣一职。

4月30日，阿末扎希表示，他已于14名森州巫统议员展开讨论，并达成共识，以已继续留在州团结政府，确保森州政局稳定。

5月4日，国盟中的2个土团党州议员宣布改变立场，保持中立。森州政治危机暂告一段落。

<heading>州议会解散</heading>
5月16日，柔佛州务大臣翁哈菲兹高调宣布，将在柔佛竞选全部56个州议席，正式关上与希盟协商合作的大门。

次日（5月17日），希望联盟也在柔佛新山召开誓师大会。

行动党秘书长陆兆福直接摆出以牙还牙的姿态，宣布在森美兰也将全面开打36席。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.22.13_PM.jpeg

由于巫统坚持不合作，森美兰州务大臣阿敏努丁于6月4日宣布，在次日（6月5日）解散州议会。

<heading>纳扎鲁丁登基不受承认</heading>
森美兰议会正式解散（6月5日）当天上午，对严端不满的四大酋长，准备在淡边Tunku Besar官邸召开DKU会议，以推选东姑纳扎鲁丁为新严端。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.22.53_PM.jpeg

但是原本准备出席会议的东姑纳扎鲁丁，却被警方限制行动，在马六甲一间酒店内不得离开，淡边Tunku Besar官邸的会议告吹。

结果四大酋长去到马六甲酒店，并在酒店内完成新严端的登基仪式，这也使得森州出现罕见的“一州两主”的局面。

无论如何，联邦政府与森州王室，都坚称登基不受森州宪法承认，强调端姑慕里兹仍是唯一的合法统治者。
`;

const negerisembilan_zh_TW = `
森美蘭政治發展史可分為傳統與現代兩個階段。傳統上，森州源自印尼蘇門答臘的米南加保傳統宗族與母系習俗（Adat perpatih），實行全馬獨有的「四大酋長」推選最高統治者（嚴端，Yamtuan）的制度。

<heading>米南加保母系習俗</heading>
米南加保人來到馬來半島後，他們所組成的部落原本受到馬六甲蘇丹國及後來的柔佛蘇丹國的保護。但在18世紀，柔佛勢力衰弱後，部落領袖為了團結抵禦外部，尤其是武吉斯人的威脅，決定從米南加保故鄉的Pagaruyung王國，請求派遣王族成員成為他們的統治者。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.12.51_PM.jpeg

1773年，來自Pagaruyung的Raja Melewar（又稱Raja Mahmud Sultan Abdul Jalil）在森美蘭，擊敗當時已自立為統治者的Raja Khatib，柔佛蘇丹因此冊封Raja Melewar為第一任嚴端，並成為森美蘭王室的開創者。

至於四大酋長，是森美蘭州內地位最高的傳統領袖。他們是在州屬王室體制中扮演關鍵決策角色的傳統領袖，但本身並不是君主。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.14.23_PM.jpeg

與世襲制君主不同，酋長並非採取「父傳子」的直接繼承方式。相反地，他們的任命遵循一套層層遞進的習俗等級制度，從部族成員（Anak buah）中，選出中級首領（Buapak）、再選出高級首領（Lembaga）、最後選出酋長（Undang）。

選拔過程同樣遵循米南加保母系制度，意即血統追溯自母系，儘管領導職位是由各領地合格貴族家庭中的男性出任。

森美蘭四大酋長分別掌管雙溪烏絨、林茂、日叻務及柔河。他們是州內傳統最高領袖，在州統治體系中扮演關鍵角色。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.14.51_PM.jpeg

19世紀末，森美蘭因為錫礦利益引發內戰，英國勢力趁機介入。1887年，英國與各部落酋長簽署條約，正式成立森美蘭聯邦。

1898年，神安池的嚴端與四大酋長達成協議，確立了「森美蘭最高統治者」的領導地位。隨後，森美蘭與其他三個州屬（霹靂、雪蘭莪及彭亨）合併為「馬來聯邦」後，1909年組成「聯邦理事會」（Federal Council），這是馬來聯邦下的立法機構。

<heading>巫統長期執政</heading>
1957年馬來亞獨立，森美蘭也在1959年舉行的第1屆全國大選。從1959年到2023年，森美蘭總共舉行過15場州選，其中前14場州選都是與全國大選同步進行。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.23.27_PM.jpeg

巫統通過聯盟/國陣贏得前13場選舉並長期執政，直到2018的第14屆全國大選，希盟首次打破國陣的壟斷，並推出公正黨的拿督斯里阿敏努丁成為第11任州務大臣。

上一屆（2023年）州選，森美蘭與另外5州舉行「六州選舉」。由於這時希盟及國陣已在聯邦組成昌明政府，森州希盟及國陣首次聯手，結果掌握超過大部分議席，成功保住森州政權。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.18.03_PM.jpeg

<heading>宮廷大臣雙重危機</heading>
2026年4月，森州爆發罕見的王室傳統與憲政糾紛，最終迫使州務大臣阿敏努丁不得不提前解散州議會。

森州宮廷與酋長的分裂，起源於雙溪烏絨家族議會議長（Telaga Undang）提出罷免其酋長慕巴拉克，並獲得由嚴端為主席的司法與酋長理事會（DKU）的認可。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.18.25_PM.jpeg

在2026年4月17日的DKU會議上，嚴端主持會議，強行通過了終止慕巴拉克的職務，引起四大酋長強烈不滿，在4月19日宣布罷黜森州最高統治者，並擁立第10任嚴端東姑查化之子納扎魯丁（Tunku Nadzaruddin Tuanku Jaafar），出任森州新任最高統治者。

阿敏努丁當晚卻宣布，罷黜嚴端的決定無效，並認定DKU會議已是最終的決定。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.20.51_PM.jpeg

阿敏努丁的聲明又激起四大酋長的不滿。次日（4月20日），森州四大酋長發表聯合聲明，譴責州務大臣插手州統治者事務，應當被撤換。

4月23日，森美蘭州議會開幕禮，四大酋長與淡邊東姑勿剎，一反傳統，集體缺席開幕儀式。開幕儀式一結束，森州議長馬上宣布，展延州議會，復會日期另行通知。

<heading>巫統撤回支持</heading>
4月27日，巫統森州主席賈拉魯丁在無預警下突然宣布，14名國陣巫統州議員決定撤回對森州大臣的支持。同一天，國盟的5名州議員宣布，願意與巫統組成新政府。

根據形勢，在森州議會中，希盟共有17席、國陣14席、國盟5席。若國陣加國盟，剛好可以過半。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.21.39_PM.jpeg

不過，阿敏努丁隨後召開記者會指出，自己已獲森州最高統治者端姑慕里茲的御准，繼續出任森州大臣一職。

4月30日，阿末扎希表示，他已於14名森州巫統議員展開討論，並達成共識，以已繼續留在州團結政府，確保森州政局穩定。

5月4日，國盟中的2個土團黨州議員宣布改變立場，保持中立。森州政治危機暫告一段落。

<heading>州議會解散</heading>
5月16日，柔佛州務大臣翁哈菲茲高調宣布，將在柔佛競選全部56個州議席，正式關上與希盟協商合作的大門。

次日（5月17日），希望聯盟也在柔佛新山召開誓師大會。

行動黨秘書長陸兆福直接擺出以牙還牙的姿態，宣布在森美蘭也將全面開打36席。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.22.13_PM.jpeg

由於巫統堅持不合作，森美蘭州務大臣阿敏努丁於6月4日宣布，在次日（6月5日）解散州議會。

<heading>納扎魯丁登基不受承認</heading>
森美蘭議會正式解散（6月5日）當天上午，對嚴端不滿的四大酋長，準備在淡邊Tunku Besar官邸召開DKU會議，以推選東姑納扎魯丁為新嚴端。

https://www.orientaldaily.com.my/images/uploads/news/2026/JULY_2026/20260716/WhatsApp_Image_2026-07-16_at_4.22.53_PM.jpeg

但是原本準備出席會議的東姑納扎魯丁，卻被警方限制行動，在馬六甲一間酒店內不得離開，淡邊Tunku Besar官邸的會議告吹。

結果四大酋長去到馬六甲酒店，並在酒店內完成新嚴端的登基儀式，這也使得森州出現罕見的「一州兩主」的局面。

無論如何，聯邦政府與森州王室，都堅稱登基不受森州憲法承認，強調端姑慕里茲仍是唯一的合法統治者。
`;

export const backgroundArticles = {
  johor: { zh_CN: johor_zh_CN, zh_TW: johor_zh_TW },
  negerisembilan: { zh_CN: negerisembilan_zh_CN, zh_TW: negerisembilan_zh_TW },
};

export default backgroundArticles;
